export default {
  title: 'HKLII 工具列',
  predictor: '港大人工智能律师<br/>贩毒罪量刑估算程式',
  predictor_desc: '本程式利用人工智慧的力量来估算香港法例第134章《危险药物条例》第4(1)(a)条中关于贩运危险药物罪的量刑。',
  sqe: '案件统计分析程式',
  sqe_desc: '开发团队收集了多份人身伤害案件和贩毒案件的判决书，构建了此统计查询引擎，使用户可以向统计查询引擎提交查询来有效地执行复杂的数据分析。',
  summary: '案件概要', // change to case highlight?
  summary_desc: '案件概要利用 AI 技术挑选判决书重点，让用户快速掌握 2020 年或以前人身伤害案件的各方资讯。',
  tag_stats: '#统计',
  tag_summary: '#摘要',
  tag_pi: '#人身伤害',
  tag_dt: '#贩毒',
  tag_sentence: '#量刑',
}